import { configureStore } from "@reduxjs/toolkit"
import { ehrApi, ehrMiddleware, ehrReducers } from "./api/api-slice.ts"
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux"
import { setupListeners } from "@reduxjs/toolkit/query"
import { uiPreferencesReducer } from "@/store/uiPreferences.ts"

export const store = configureStore({
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(ehrMiddleware),
  reducer: {
    [ehrApi.reducerPath]: ehrReducers,
    uiPreferences: uiPreferencesReducer,
  },
})
setupListeners(store.dispatch)
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
export const useAppDispatch: () => AppDispatch = useDispatch
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
